import { render, staticRenderFns } from "./RequestCollection.vue?vue&type=template&id=50878e37&"
import script from "./RequestCollection.vue?vue&type=script&lang=js&"
export * from "./RequestCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports